const config = {
    apiDomain: 'www.fjfeiyi.com',//不要带斜杠
    fileDomain: 'www.fjfeiyi.com',//文件上传
    isHttps: true,
    timeOut: 10000,//请求超时时间
    apiList: {
        upload: {
            url: "/api/common/upload_image",
            method: 'post',
            comment: "上传图片"
        },
        uploadFile: {
            url: "/api/common/upload_file",
            method: 'post',
            comment: "上传文件"
        },
        home: {
            url: "/api/app/home",
            method: 'get',
            comment: "首页基础信息"
        },
        projectList: {
            url: "/api/app/project/list",
            method: 'get',
            comment: "项目列表"
        },
        projectCountByLevel: {
            url: "/api/app/project/count_by_level",
            method: 'get',
            comment: "项目数量"
        },
        projectDetails: {
            url: "/api/app/project/details",
            method: 'get',
            comment: "项目详情"
        },

        imagesList: {
            url: "/api/app/images/list",
            method: 'get',
            comment: "图集列表"
        },
        newsList: {
            url: "/api/app/news/list",
            method: 'get',
            comment: "资讯列表"
        },
        newsDetails: {
            url: "/api/app/news/details",
            method: 'get',
            comment: "资讯详情"
        },
        addViews: {
            url: "/api/app/stat/add_views",
            method: 'get',
            comment: "增加访问"
        }

    }
};

export default config;
